// extracted by mini-css-extract-plugin
module.exports = {"button":"detail-page-pwa-back-button_button__yKHT0","button__icon":"detail-page-pwa-back-button_button__icon__alQqB"};